export const ACCESS_TOKEN_PAYLOAD_NAME_KEY =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name";
export const ACCESS_TOKEN_PAYLOAD_NAME_IDENTIFIER_KEY =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";
export const ACCESS_TOKEN_PAYLOAD_ROLE_KEY =
  "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";
export const FacilityKey = "FacilityKey";
